"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelayMessageSubType = exports.RelayMessage = exports.TrackerMessageType = exports.TrackerMessage = exports.StatusAckMessage = exports.StatusMessage = exports.ErrorMessage = exports.InstructionMessage = void 0;
const InstructionMessage_1 = __importDefault(require("./instruction_message/InstructionMessage"));
exports.InstructionMessage = InstructionMessage_1.default;
const ErrorMessage_1 = __importDefault(require("./error_message/ErrorMessage"));
exports.ErrorMessage = ErrorMessage_1.default;
const RelayMessage_1 = __importStar(require("./relay_message/RelayMessage"));
exports.RelayMessage = RelayMessage_1.default;
Object.defineProperty(exports, "RelayMessageSubType", { enumerable: true, get: function () { return RelayMessage_1.RelayMessageSubType; } });
const StatusMessage_1 = __importDefault(require("./status_message/StatusMessage"));
exports.StatusMessage = StatusMessage_1.default;
const StatusAckMessage_1 = __importDefault(require("./status_ack_message/StatusAckMessage"));
exports.StatusAckMessage = StatusAckMessage_1.default;
const TrackerMessage_1 = __importDefault(require("./TrackerMessage"));
exports.TrackerMessage = TrackerMessage_1.default;
const TrackerMessage_2 = require("./TrackerMessage");
Object.defineProperty(exports, "TrackerMessageType", { enumerable: true, get: function () { return TrackerMessage_2.TrackerMessageType; } });
// Serializers are imported because of their side effects: they statically register themselves to the factory class
require("./error_message/ErrorMessageSerializerV2");
require("./instruction_message/InstructionMessageSerializerV2");
require("./relay_message/RelayMessageSerializerV2");
require("./status_message/StatusMessageSerializerV2");
require("./status_ack_message/StatusAckMessageSerializerV2");
//# sourceMappingURL=index.js.map